import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M517.257332,1127.34303 C589.989778,1127.34303 666.128124,1163.92899 738.530966,1234.79369 C825.985689,1345.21077 853.452625,1438.92795 820.162699,1513.08868 C747.430253,1675.36333 407.499457,1747.98591 201.49744,1772.26668 C236.105779,1689.64614 276.646976,1555.38776 276.646976,1377.62175 C276.646976,1280.49867 343.11696,1182.16704 434.526922,1143.93306 C461.224784,1132.83642 489.021323,1127.34303 517.257332,1127.34303 Z M746.661179,960.234197 C800.716108,989.129413 853.123022,1025.6055 901.794432,1073.72758 L915.637767,1089.32879 C943.654042,1124.70621 966.286797,1159.31455 986.06299,1193.48341 C956.508567,1219.74181 926.185071,1246.21993 895.312235,1273.02766 C876.414983,1237.54038 852.24408,1201.06429 822.469921,1163.70926 L818.185079,1158.87508 C769.843273,1111.19248 718.754772,1075.48546 666.457727,1051.86389 C692.825985,1021.21079 719.523847,990.667562 746.661179,960.234197 Z M1793.15143,157.100998 C1800.95204,164.901608 1811.27961,178.854811 1810.07106,209.288176 C1804.02833,364.970767 1525.73334,703.693018 1069.56247,1118.55361 C1049.56655,1086.2525 1027.593,1053.73165 1001.77408,1021.10093 L979.25119,995.831346 C930.030442,947.159936 877.843264,906.948342 823.238996,874.757093 C1173.82696,488.901581 1551.44239,140.401101 1733.49324,132.929113 C1764.47595,132.820227 1777.98968,141.93925 1793.15143,157.100998 Z M1919.82894,213.573018 C1921.91642,159.95756 1904.99679,113.593372 1863.68652,72.283101 C1829.40778,38.0043653 1781.72518,21.084733 1729.09853,23.1722201 C1424.54515,35.587275 816.866667,706.549579 549.558449,1019.34304 C495.94299,1013.95952 442.876871,1021.43053 392.117974,1042.74487 C259.507608,1098.00835 166.779233,1235.7825 166.779233,1377.62175 C166.779233,1646.13851 62.8443488,1803.35925 61.8555391,1804.8974 L0,1896.74684 L110.307214,1890.59424 C179.523891,1886.85874 791.597086,1845.21886 920.471948,1558.13445 C944.862587,1503.53018 949.696767,1444.97068 936.402771,1382.8954 C1310.72217,1061.09278 1908.51256,503.184388 1919.82894,213.573018",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPaintLine = /*#__PURE__*/function (_Component) {
  _inherits(IconPaintLine, _Component);

  var _super = _createSuper(IconPaintLine);

  function IconPaintLine() {
    _classCallCheck(this, IconPaintLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconPaintLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPaint",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPaintLine.displayName = "IconPaintLine";
  return IconPaintLine;
}(Component);

IconPaintLine.glyphName = 'paint';
IconPaintLine.variant = 'Line';
IconPaintLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPaintLine;
export { IconPaintLine };